<section class="playground">
  <h2 class="playground__heading">Panel</h2>
  <p class="playground__hint">
    <code>common-panel</code> — card clickable con título, subtítulo opcional y hasta 4 descripciones en el footer.
    Figma componentSet <code>240:29049</code>.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>title</span>
        <input type="text" [(ngModel)]="title" />
      </label>

      <label class="playground__field">
        <span>subtitle</span>
        <input type="text" [(ngModel)]="subtitle" />
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showSubtitle" />
        <span>showSubtitle</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showFooter" />
        <span>showFooter (muestra descripciones)</span>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="showPanelBorder" />
        <span>bordered (borde visible; si off, hover con sombra)</span>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview — dinámico</p>
      <div class="playground__preview-box">
        <common-panel
          [data]="dynamicData"
          (select)="onSelect('dinámico')"
        ></common-panel>
      </div>

      <p class="playground__preview-title" style="margin-top: 24px">Variante simple (sin footer)</p>
      <div class="playground__preview-box">
        <common-panel
          [data]="simpleData"
          (select)="onSelect('simple')"
        ></common-panel>
      </div>

      <p class="playground__preview-title" style="margin-top: 24px">Variante detallada (con footer)</p>
      <div class="playground__preview-box">
        <common-panel
          [data]="detailedData"
          (select)="onSelect('detallada')"
        ></common-panel>
      </div>

      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>
